import React from "react";
import Banner from "./components/Banner";
import Blog from "./components/Blog";
import Project from "./components/Project";
// import WorkProcess from "./components/WorkProcess";

const Home = () => {
	return (
		<>
			<Banner />
			{/* <WorkProcess /> */}
			<Project />
			<Blog />
		</>
	);
};

export default Home;
